import { City, CountryCode, PostCode, StateProvince } from 'containers/FPLOrderRequestList/Fields'
import {
  AddressLine1,
  AddressLine2,
  CartonDescription,
  CartonsNumber,
  RecipientEmail,
  RecipientName,
  Height,
  HsCode,
  Length,
  ShipperOrderNumber,
  TotalCartonValue,
  Weight,
  Width,
  RequestedCartonTIDs,
  RequestedTrackingID,
  RDOorGRN,
  InlineDescription,
  NoOfParcel,
  GoodsValue,
  ShipperBoxId,
  RecipientContact,
  RecipientAddress,
  LengthInShort,
  WidthInShort,
  HeightInShort
} from './MMCCFields'
import { STANDARD_MMCC_FIELDS } from './constants'

export const FORM_FIELDS_BY_SECTION = {
  recipient: [
    [STANDARD_MMCC_FIELDS.NAME, RecipientName, 8, false], // [component_key, Component, the width of column, customization fields]. Example the width of column: <Col lg={8}>{children}</Col>
    [STANDARD_MMCC_FIELDS.CONTACT, RecipientContact, 8, false],
    [STANDARD_MMCC_FIELDS.EMAIL, RecipientEmail, 8, false],
    [STANDARD_MMCC_FIELDS.NUMBER_OF_CARTONS, CartonsNumber, 8, false],
    [STANDARD_MMCC_FIELDS.TOTAL_CARTON_VALUE, TotalCartonValue, 8, false],
    [STANDARD_MMCC_FIELDS.SHIPPER_ORDER_NUMBER, ShipperOrderNumber, 8, false]
  ],
  address: [
    [STANDARD_MMCC_FIELDS.POSTCODE, PostCode, 8, false],
    [STANDARD_MMCC_FIELDS.STATE_PROVINCE, StateProvince, 8, false],
    [STANDARD_MMCC_FIELDS.CITY, City, 8, false],
    [STANDARD_MMCC_FIELDS.ADDRESS_LINE_1, AddressLine1, 12, false],
    [STANDARD_MMCC_FIELDS.ADDRESS_LINE_2, AddressLine2, 12, false]
  ],
  carton: [
    [STANDARD_MMCC_FIELDS.WEIGHT, Weight, 6, false],
    [STANDARD_MMCC_FIELDS.LENGTH, Length, 6, false],
    [STANDARD_MMCC_FIELDS.WIDTH, Width, 6, false],
    [STANDARD_MMCC_FIELDS.HEIGHT, Height, 6, false],
    [STANDARD_MMCC_FIELDS.RDO_REQUIRED, RDOorGRN, 24, false],
    [STANDARD_MMCC_FIELDS.REQUESTED_TRACKING_ID, RequestedTrackingID, 8, false],
    [null, null, 12],
    [STANDARD_MMCC_FIELDS.REQUESTED_CARTON_TRACKING_NUMBERS, RequestedCartonTIDs, 8, false],
    [STANDARD_MMCC_FIELDS.DESCRIPTION, CartonDescription, 8, false],
    [STANDARD_MMCC_FIELDS.HSCODE, HsCode, 8, false]
  ]
}

export const RECIPIENT_MMCC_B2B_FORM_FIELDS = {
  recipient: [
    [STANDARD_MMCC_FIELDS.NAME, RecipientName, 12, false],
    [STANDARD_MMCC_FIELDS.CONTACT, RecipientContact, 12, false],
    [STANDARD_MMCC_FIELDS.ADDRESS_LINE_1, RecipientAddress, 16, false],
    [STANDARD_MMCC_FIELDS.CITY, City, 4, false],
    [STANDARD_MMCC_FIELDS.POSTCODE, PostCode, 4, false]
  ]
}

export const RECIPIENT_MMCC_B2B_FORM_FIELDS_FOR_GLOBAL_COUNTRY = {
  recipient: [
    [STANDARD_MMCC_FIELDS.NAME, RecipientName, 12, false],
    [STANDARD_MMCC_FIELDS.CONTACT, RecipientContact, 12, false],
    [STANDARD_MMCC_FIELDS.COUNTRY, CountryCode, 10, false],
    [STANDARD_MMCC_FIELDS.CITY, City, 10, false],
    [STANDARD_MMCC_FIELDS.POSTCODE, PostCode, 4, false],
    [STANDARD_MMCC_FIELDS.ADDRESS_LINE_1, RecipientAddress, 24, false]
  ]
}

export const BOX_MMCC_B2B_FORM_FIELDS = {
  box: [
    [STANDARD_MMCC_FIELDS.SHIPPER_BOX_ID, ShipperBoxId, 5, false],
    [STANDARD_MMCC_FIELDS.DESCRIPTION, InlineDescription, 5, false],
    [STANDARD_MMCC_FIELDS.NO_OF_PARCELS, NoOfParcel, 3, false],
    [STANDARD_MMCC_FIELDS.GOODS_VALUE, GoodsValue, 3, false],
    [STANDARD_MMCC_FIELDS.LENGTH, LengthInShort, 2, false],
    [STANDARD_MMCC_FIELDS.WIDTH, WidthInShort, 2, false],
    [STANDARD_MMCC_FIELDS.HEIGHT, HeightInShort, 2, false],
    [STANDARD_MMCC_FIELDS.WEIGHT, Weight, 2, false]
  ]
}

export const EDIT_BOX_MMCC_B2B_FORM_FIELDS = {
  box: [
    [STANDARD_MMCC_FIELDS.SHIPPER_BOX_ID, ShipperBoxId, 12, false],
    [STANDARD_MMCC_FIELDS.NO_OF_PARCELS, NoOfParcel, 6, false],
    [STANDARD_MMCC_FIELDS.GOODS_VALUE, GoodsValue, 6, false],
    [STANDARD_MMCC_FIELDS.DESCRIPTION, InlineDescription, 24, false],
    [STANDARD_MMCC_FIELDS.LENGTH, Length, 6, false],
    [STANDARD_MMCC_FIELDS.WIDTH, Width, 6, false],
    [STANDARD_MMCC_FIELDS.HEIGHT, Height, 6, false],
    [STANDARD_MMCC_FIELDS.WEIGHT, Weight, 6, false]
  ]
}
